// Admin Users Types
export enum UserRole {
  ADMIN = 'admin',
  SUB_ADMIN = 'sub-admin',
  SUPER_ADMIN = 'super-admin',
  SALES = 'sales',
  SUPPORT = 'support',
}

export enum UserStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  SUSPENDED = 'suspended',
}

export interface User {
  id: string;
  fullName: string;
  email: string;
  employee_id?: string;
  employeeId?: string;
  phone?: string;
  role: UserRole;
  status: UserStatus;
  createdAt: string;
  updatedAt: string;
  roleId?: string;
  isDeleted?: boolean;
}

export interface UsersListResponse {
  users: User[];
  total: number;
  page: number;
  limit: number;
}

export interface UserFilters {
  page?: number;
  limit?: number;
  role?: UserRole;
  status?: UserStatus;
  search?: string;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
}

export interface DashboardStats {
  suspendedUsers: number;
  inactiveUsers: number;
  totalUsers: number;
  activeUsers: number;
  newUsersToday: number;
  usersByRole: Record<UserRole, number>;
}

export interface RegisterUserRequest {
  email: string;
  password: string;
  fullName: string;
  role: UserRole;
  tenantSlug: string;
}

export interface RegisterUserResponse {
  message: string;
  data: User;
}
